export let Gender;

(function (Gender) {
  Gender["Neutral"] = "";
  Gender["Female"] = "_f";
  Gender["Male"] = "_m";
})(Gender || (Gender = {}));

export const genders = Object.values(Gender);
export const gendersWithoutNeutral = genders.filter(value => !!value);